import styled from "styled-components";
import headerLogo from '../../img/main/header_logo.png';
import mobileLogo from '../../img/main/mobile_logo.png';
import { flexColumn, flexNoneEnd } from '../../styles/mixins.style';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function SubHeader() {
	const location = useLocation();
	const [isTablet, setIsTablet] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setIsTablet(window.innerWidth <= 1024);
		};
		handleResize();
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<SubHeaderWrapper>
			<Nav>
				<MobileLogoLink to="/">
					<img src={mobileLogo} alt="모바일 로고" />
				</MobileLogoLink>
				<NavList>
					{isTablet ? (
						<>
							<li>
								<NavLink to="/stay" $active={location.pathname === '/stay'}>STAY</NavLink>
							</li>
							<LogoWrap>
								<LogoLink to="/" className="hidden1024">
									<img src={headerLogo} alt="로고" />
								</LogoLink>
								<LogoTextLink to="/">HORIGUL</LogoTextLink>
							</LogoWrap>
							<li>
								<NavLink to="/reservation" $active={location.pathname === '/reservation'}>RESERVATION</NavLink>
							</li>
						</>
					) : (
						<>
							<LogoWrap>
								<LogoLink to="/" className="hidden1024">
									<img src={headerLogo} alt="로고" />
								</LogoLink>
								<LogoTextLink to="/">HORIGUL</LogoTextLink>
							</LogoWrap>
							<li>
								<NavLink to="/stay" $active={location.pathname === '/stay'}>STAY</NavLink>
							</li>
							<li>
								<NavLink to="/reservation" $active={location.pathname === '/reservation'}>RESERVATION</NavLink>
							</li>
						</>
					)}
				</NavList>
			</Nav>
		</SubHeaderWrapper>
	);
}

const SubHeaderWrapper = styled.div`
	color: #fff;
	background: #000;
	width: 250px;
	height: 100vh;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1000;
	${flexColumn}
	align-items: center;
    justify-content: center;
	font-family: 'Pretendard', sans-serif;

	@media (max-width: 1024px) {
		width: 100vw;
		height: 120px;
		position: fixed;
		top: 0;
		left: 0;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}
	@media (max-width: 768px) {
		height: 4.875rem;
	}
`;

const Nav = styled.nav`
	width: 100%;
	${flexColumn}
	align-items: center;

	@media (max-width: 1024px) {
		width: 90%;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		height: 100%;
	}
`;

const MobileLogoLink = styled(Link)`
	display: none;
	@media (max-width: 1024px) {
		display: block;
		margin-right: 2rem;
	}
`;

const NavList = styled.ul`
	padding: 0;
	margin: 0;
	${flexColumn}
	gap: 2.5rem;
	align-items: center;
	list-style: none;

	@media (max-width: 1024px) {
		flex-direction: row;
		gap: 2rem;
		align-items: center;
	}
	@media (max-width: 768px) {
		gap: 1rem;
	}
`;

const LogoWrap = styled.li`
	${flexColumn}
	align-items: center;
	gap: 1rem;

	@media (max-width: 1024px) {
		flex-direction: row;
		align-items: center;
		gap: 0.75rem;
	}
`;

const LogoLink = styled(Link)`
	display: block;
	&.hidden1024 {
		display: block;
	}
`;

const LogoTextLink = styled(Link)`
	font-size: 1rem;
	color: #ffffff50;
	text-decoration: none;
	margin-top: 0.25rem;
	@media (max-width: 768px) {
		margin-top: 0;
	}
`;

const NavLink = styled(Link)<{ $active?: boolean }>`
	color: ${({ $active }) => $active ? '#fff' : '#ffffff50'};
	font-weight: ${({ $active }) => $active ? '500' : '400'};
	text-align: center;
	transition: color 0.3s ease;
	font-size: 1rem;
	text-decoration: none;
	margin-top: 0.5rem;
	&:hover {
		color: #fff;
	}
`;